import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {WorkDayModel} from '../time-tracker-model/work-day.model';
import {WorkTimeRangeModel} from '../time-tracker-model/work-time-range.model';
import {DialogService} from '../../../dialog/dialog.service';
import {WorkDayType} from '../time-tracker-model/work-day-type.enum';

interface DisplayRange {
  offset: string;
  duration: string;
  type?: any;
  status: string;
  id: number;
}

@Component({
  selector: 'app-time-tracker-work-day',
  templateUrl: './time-tracker-work-day.component.html',
  styleUrls: ['./time-tracker-work-day.component.css']
})
export class TimeTrackerWorkDayComponent implements OnInit {

  @Input() formIndex: number;
  @Input() data: WorkDayModel;
  @Input() active: boolean;
  @Input() isHoliday: boolean;
  @Input() day20DaysAhead: Date;

  @Output() addWorkTimeRangeRequest = new EventEmitter();
  @Output() saveWorkTimeRangeRequest = new EventEmitter();
  @Output() deleteWorkTimeRangeRequest = new EventEmitter();

  DAY_LENGTH = 86400000; // 24 * 60 * 60 * 1000;
  weekDays: string[] = [
    'TIMETRACKER.WEEK_DAY_ZERO',
    'TIMETRACKER.WEEK_DAY_ONE',
    'TIMETRACKER.WEEK_DAY_TWO',
    'TIMETRACKER.WEEK_DAY_THREE',
    'TIMETRACKER.WEEK_DAY_FOUR',
    'TIMETRACKER.WEEK_DAY_FIVE',
    'TIMETRACKER.WEEK_DAY_SIX'
  ];

  dayType: string;
  hours: number[];
  weekDay: string;
  workDayDate: Date;
  workTimeRanges: WorkTimeRangeModel[];
  workTimeRangesDisplay: DisplayRange[] = [];
  WorkDayType = WorkDayType;

  constructor(private dialogService: DialogService) {
    this.hours = Array(25).fill(0).map((x, i) => i);
  }

  ngOnInit() {
    const day = new Date(this.data.day);
    this.workDayDate = new Date(Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), 0, 0, 0));
    this.weekDay = this.weekDays[this.workDayDate.getDay()];
    this.workTimeRanges = this.data.workTimeRanges;
    this.dayType = this.getWorkDayType(this.data.type);
    this.fillHoursRangeBar();
  }

  getWorkDayType(workDayType: string) {
    if (WorkDayType[workDayType] !== undefined) {
      return workDayType;
    }
    return WorkDayType[WorkDayType.NORMAL];
  }

  isModifiable(): boolean {
    return this.active && this.workDayDate < this.day20DaysAhead;
  }

  onAddWorkTimeRange() {
    this.dialogService.openWorkTimeRangeModal(new WorkTimeRangeModel(), this);
  }

  onEditWorkTimeRange(timeSlotWorkRangeId: number) {
    this.dialogService.openWorkTimeRangeModal(this.workTimeRanges[timeSlotWorkRangeId], this, false);
  }

  private fillHoursRangeBar() {

    this.workTimeRanges
      .filter((workTimeRange) => {
        return workTimeRange.startTime >= this.workDayDate.getTime()
          && workTimeRange.stopTime <= (this.workDayDate.getTime() + 24 * 60 * 60 * 1000);
      })
      .map((workTimeRange, workTimeRangeId) => {
          let offset = (workTimeRange.startTime - this.workDayDate.getTime()) / this.DAY_LENGTH * 100;
          if (offset > 99) {
            offset = 99;
          }
          const offsetPercentage = offset + '%';

          let duration = (workTimeRange.stopTime - workTimeRange.startTime) / this.DAY_LENGTH * 100 + '%';
          if (workTimeRange.stopTime === workTimeRange.startTime) {
            duration = '1%';
          }
          const workingTime = (workTimeRange.stopTime - workTimeRange.startTime) / this.DAY_LENGTH * 100;
          if (workingTime < 0.69) {
            duration = '0.69%';
          }
          this.workTimeRangesDisplay.push({
            id: workTimeRangeId,
            offset: offsetPercentage,
            duration: duration,
            status: workTimeRange.status
          });
        }
      );
  }

  private isDraftStatus(status: string) {
    return (!status) || status === 'DRAFT' || status === 'ACCEPTED';
  }

  private isApprovedStatus(status: string) {
    return status === 'APPROVED' || status === 'INVOICED' || status === 'INVOICE_PAID';
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/time-tracker/time-tracker-work-day/time-tracker-work-day.component.ts